import { Link } from '@fluentui/react-components';
import { useStyles } from './NavBar.styles';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import React from 'react';

export type NavBarProps = {
  brandLogo: string;
};

export const NavBar: React.FC<NavBarProps> = ({ brandLogo }) => {
  const navigate = useNavigate();
  const { signOut } = useAuthStore();
  const styles = useStyles();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error(error);
    } finally {
      console.log('Sign out');
    }
  };

  return (
    <div className={styles.navBarContainer}>
      <div className={styles.navBar}>
        <Link
          appearance="subtle"
          className={styles.brandContainer}
          target="_blank"
          href="https://www.leelalife.com/"
        >
          {/* <img src={brandLogo} alt="Brand Logo" /> */}
          <LogoSvg />
        </Link>
        <Link appearance="subtle" className={styles.signOutContainer} onClick={handleSignOut}>
          Sign out
        </Link>
      </div>
    </div>
  );
};

const LogoSvg = () => (
  <svg width="223" height="24" viewBox="0 0 223 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="logo_v2" clip-path="url(#clip0_146_2198)">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.9415 3.43074L3.20446 6.411C3.20299 6.41444 3.2 6.42344 3.2 6.43709C3.2 6.45129 3.20324 6.46046 3.20464 6.46357L3.2063 6.46479L8.77578 10.1082L14.5291 6.50977L9.621 3.40715L9.59248 3.38869C9.21187 3.13663 8.60176 3.06731 7.9415 3.43074ZM3.20448 17.5368L8.99593 13.8885L14.5598 17.4708L9.65718 20.57C8.99743 20.9326 8.38788 20.8632 8.00752 20.6113L7.97609 20.591L3.20446 17.589C3.20299 17.5856 3.2 17.5766 3.2 17.5629C3.2 17.5492 3.20301 17.5402 3.20448 17.5368ZM25.3968 20.4201L20.5194 17.447L26.17 13.8089L31.8355 17.3778C31.837 17.3813 31.84 17.3903 31.84 17.404C31.84 17.4176 31.837 17.4266 31.8355 17.4301L27.0985 20.4103C26.4382 20.7737 25.8281 20.7044 25.4475 20.4524C25.4308 20.4413 25.4139 20.4306 25.3968 20.4201ZM31.8355 6.46321L26.1575 10.0401L20.5121 6.50906L25.3828 3.43001C26.0426 3.06741 26.6521 3.1368 27.0325 3.38869L27.0639 3.40899L31.8355 6.411C31.837 6.41444 31.84 6.42344 31.84 6.43709C31.84 6.45078 31.837 6.45979 31.8355 6.46321ZM11.3518 0.733395C9.82021 -0.271707 7.88997 -0.201434 6.32618 0.686241C6.30514 0.698181 6.28438 0.710594 6.26392 0.723471L1.46392 3.74334L1.43248 3.76363C-0.477493 5.02851 -0.477493 7.84566 1.43248 9.11055L5.93236 12.0543L1.46313 14.8697L1.43248 14.8895C-0.477493 16.1543 -0.477493 18.9715 1.43248 20.2364L1.46392 20.2567L6.24982 23.2677C7.78114 24.2717 9.71058 24.2011 11.2738 23.3138C11.2959 23.3013 11.3176 23.2882 11.339 23.2747L17.5354 19.3576L23.7003 23.1156C25.23 24.1124 27.1542 24.0402 28.7138 23.1548C28.7349 23.1429 28.7556 23.1305 28.7761 23.1176L33.5761 20.0977L33.6075 20.0774C35.5175 18.8125 35.5175 15.9954 33.6075 14.7305L33.5769 14.7107L29.1476 11.9205L33.5769 9.13035L33.6075 9.11055C35.5175 7.84566 35.5175 5.02851 33.6075 3.76363L33.5761 3.74334L28.7902 0.732382C27.2589 -0.27166 25.3294 -0.201136 23.7662 0.686241C23.7441 0.698749 23.7224 0.711776 23.701 0.725311L17.52 4.63262L11.3518 0.733395ZM11.853 11.9399L17.5211 15.5894L23.1892 11.9399L17.5211 8.39476L11.853 11.9399ZM82.5254 5.21614V0.640137H64.6054V23.0401H82.7494V18.4641H69.7254V13.8881H81.5974V9.53614H69.7254V5.21614H82.5254ZM201.649 5.21614V0.640137H184.465V23.0401H189.585V14.7841H200.593V10.4321H189.585V5.21614H201.649ZM222.24 5.21614V0.64014H204.32V23.0401H222.464V18.4641H209.44V13.8881H221.312V9.53614H209.44V5.21614H222.24ZM181.266 0.672168V23.0402H176.146V0.672168H181.266ZM162.481 18.4641V0.64014H157.361V23.0401H173.873V18.4641H162.481ZM139.16 0.64014L148.376 23.0401H142.296L140.536 18.6241H131.16L129.432 23.0401H123.352L132.504 0.64014H139.16ZM135.832 6.30414L132.536 14.5601H139.16L135.832 6.30414ZM111.417 18.4641V0.64014H106.297V23.0401H122.809V18.4641H111.417ZM103.373 0.64014V5.21614H90.5731V9.53614H102.445V13.8881H90.5731V18.4641H103.597V23.0401H85.4531V0.64014H103.373ZM50.9442 0.64014V18.4641H62.3362V23.0401H45.8242V0.64014H50.9442Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_146_2198">
        <rect width="222.4" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
